import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

// inicializa ReactGA con el ID de seguimiento
// const initializeReactGA = (trackingId) => {
//   ReactGA.initialize(trackingId);
// };

// realiza el seguimiento de la página
const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

// Hook personalizado para utilizar Google Analytics
const useGoogleAnalytics = (trackingId, location) => {
  // Asegurarse de que ReactGA solo se inicialice una vez utilizando useMemo
  useMemo(() => {
    if (!trackingId) {
      console.error("Falta el ID de seguimiento de Google Analytics.");
      return;
    }

    // if (!ReactGA.ga) {
    //   initializeReactGA(trackingId);
    // }
  }, [trackingId]);

  // Realizar el seguimiento de las páginas cada vez que la ubicación cambia
  useEffect(() => {
    try {
      trackPageView(location.pathname + location.search);
    } catch (error) {
      console.error("Error al realizar el seguimiento de la página:", error);
    }
  }, [location]);
};

const GoogleAnalyticsReporter = ({ trackingId }) => {
  // Obtenemos la ubicación actual del usuario utilizando el hook useLocation
  const location = useLocation();

  // Usamos el hook personalizado useGoogleAnalytics con el trackingId y la ubicación
  useGoogleAnalytics(trackingId, location);

  return null;
};

export default GoogleAnalyticsReporter;
